import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { GET_SCENARIO_OBSTACLES } from '../../queries/scenario'

export default function ObstacleLayer(props) {
  const { selectedScenarioId, remoteStorage } = useSelector(state => state)

  if (remoteStorage.obstacles) {
    const { loading, error, refetch } = useQuery(GET_SCENARIO_OBSTACLES, {
      variables: { id: selectedScenarioId },
      onCompleted: data => {
        console.log('GET_SCENARIO_OBSTACLES on completed')
        if (data && data.scenario) {
          data.scenario.obstacles.map(obstacle => {
            props.draw.add(JSON.parse(obstacle.geojson))
          })
        }
      },
    })

    if (loading) return null
    if (error) return `Error! ${error}`

    refetch()
  }

  return null
}
